'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _session = require('../../../session');

var _session2 = _interopRequireDefault(_session);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.routes.errors.not-authorized', ['ui.router', 'ifeis.session', 'ngCookies']).config(function ($stateProvider) {
  $stateProvider.state('not-authorized', {
    url: '/not-authorized',
    controller: 'NotAuthorizedController',
    template: require('./tpl.html')
  });

  $stateProvider.state('check-auth', {
    resolve: {
      user: function user(fSession, $location, $state, $cookieStore) {
        return fSession.user().then(function () {
          $state.go('not-authorized', {}, { location: false });
        }, function () {
          $cookieStore.put('IFEIS_REDIRECT_URL', $location.path());
          $state.go('login');
        });
      }
    }
  });
}).controller('NotAuthorizedController', function ($scope) {});


//////////////////
// WEBPACK FOOTER
// ./routes/errors/not-authorized/index.js
// module id = 533
// module chunks = 0